import type { ReactNode } from 'react';
import { cn, PaletteUtils } from '@shared/utils';
import { Text } from '@shared/widgets';

interface SidebarSectionProps {
  className?: string;
  caption?: ReactNode;
  children: ReactNode;
}

export const SidebarSection = (props: SidebarSectionProps) => {
  return (
    <section
      className={cn(
        'flex w-80 flex-col gap-6 bg-white p-6 dark:bg-soft-black',
        PaletteUtils.isVcfcPalette && 'rounded-xl p-6 dark:border dark:border-gray-black dark:bg-soft-black',
        'max-[1440px]:w-full',
        props.className,
      )}
    >
      <Text tag='h3' weight='semibold' size='base'>
        {props.caption}
      </Text>
      {props.children}
    </section>
  );
};
